angular.module('bmsApp.settings').factory('GroupSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		index: function(params){return CRUDSvc.get('api/role/index', params);},
		create: function (data) {return CRUDSvc.create('api/role/create', data);},
		update: function (data) {return CRUDSvc.update('api/role/update', data);},
		delete: function(params) {return CRUDSvc.delete('api/role/delete', params);}
	}

});



